export interface RGB {
  r: number;
  g: number;
  b: number;
}
export const hexToRgb = (hex: string): RGB => {
  // Remove the hash if it exists
  const cleanedHex = hex.replace("#", "");

  // Parse the hex values
  const bigint = parseInt(cleanedHex, 16);

  // Extract RGB components
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return { r, g, b };
};
